// src/services/condominiosService.js
// Camada de serviço que conecta o frontend React à API NodeJS

import api from "./api";
const condominiosService = {
  /**
   * Listar com paginação e filtros
   * @param {Object} params - { search, tipo, status, page, limit, orderBy, order }
   */
  listar: (params = {}) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== "") qs.set(k, v); });
    return api("GET", `/condominios?${qs.toString()}`);
  },

  /** Buscar por ID */
  buscarPorId: (id) => api("GET", `/condominios/${id}`),

  /** Criar novo */
  criar: (data) => api("POST", "/condominios", data),

  /** Atualizar */
  atualizar: (id, data) => api("PUT", `/condominios/${id}`, data),

  /** Excluir */
  deletar: (id) => api("DELETE", `/condominios/${id}`),

  /** Ativar / Inativar */
  alterarStatus: (id, inativo) => api("PATCH", `/condominios/${id}/status`, { inativo }),

  // (12) Documentos do condomínio
  listarDocumentos:  (id)        => api("GET",    `/condominios/${id}/documentos`),
  uploadDocumento:   (id, data)  => api("POST",   `/condominios/${id}/documentos`, data),
  baixarDocumento:   (id, docId) => api("GET",    `/condominios/${id}/documentos/${docId}`),
  excluirDocumento:  (id, docId) => api("DELETE", `/condominios/${id}/documentos/${docId}`),

  // (13) Alertas de seguro vencendo
  seguroAlertas:     (dias=30)   => api("GET",    `/condominios/seguro/alertas?dias=${dias}`),

  /** Configuração de aprovação de contas a pagar */
  buscarConfigAprovacao: (id) => api("GET", `/condominios/${id}/config-aprovacao`),
  salvarConfigAprovacao: (id, data) => api("PUT", `/condominios/${id}/config-aprovacao`, data),
};

// (9) Integrações públicas (BrasilAPI)
export const integracoesService = {
  consultarCnpj: (cnpj) => api("GET", `/integracoes/cnpj/${(cnpj||"").replace(/\D/g,"")}`),
  consultarCep:  (cep)  => api("GET", `/integracoes/cep/${(cep||"").replace(/\D/g,"")}`),
};

export default condominiosService;
